/** Shown on every 403; the session stays signed in. */
export const NO_ACCESS_MESSAGE = "You don't have access to this action. Please contact the administrator.";
